module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogGeography.tabs.usage":"Usage","views.dialogGeography.tabs.carbon":"Emissions"}}')
  delete Component.options._Ctor
}
